export type ParsedSemver = {
  major: number;
  minor: number;
  patch: number;
};

export function parseSemver(version: string | null): ParsedSemver | null {
  if (!version) return null;

  const match = version.match(/^(\d+)\.(\d+)(?:\.(\d+))?(?:-[\w-.]+)?(?:\+[\w-.]+)?$/);
  if (!match) return null;
  if (match[1] === undefined || match[2] === undefined) return null;

  return {
    major: Number.parseInt(match[1], 10),
    minor: Number.parseInt(match[2], 10),
    patch: match[3] !== undefined ? Number.parseInt(match[3], 10) : 0,
  };
}

/** Negative when `a` < `b`, positive when `a` > `b`, `0` when equal, `null` if unparseable. */
export function compareSemver(a: string, b: string): number | null {
  const parsedA = parseSemver(a);
  const parsedB = parseSemver(b);

  if (!parsedA || !parsedB) return null;

  if (parsedA.major !== parsedB.major) return parsedA.major - parsedB.major;
  if (parsedA.minor !== parsedB.minor) return parsedA.minor - parsedB.minor;
  return parsedA.patch - parsedB.patch;
}
